import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import _ from 'lodash';

import TripCard from '../TripCard/TripCard';
import { useGetFilteredTours } from '../../hooks/useGetFilteredTours';
import { setCurrentPage } from '../../redux/actions/setCurrentPage';
import { getCurrentPage } from '../../redux/reducers/page';
import { getCardsPerPage } from '../../redux/reducers/configuration';

import '../../styles/scss/elements/trips-container.scss';
import '../../styles/scss/elements/pagination.scss';

const TripsContainer = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector(getCurrentPage);
  const trips = useGetFilteredTours();
  const PER_PAGE = useSelector(getCardsPerPage);
  const [data, setData] = useState(trips ? trips : []);

  useEffect(() => {
    setData(trips);
  }, [trips]);

  const offset = currentPage * PER_PAGE;
  const currentPageData =
    _.size(data) > 0 &&
    data.slice(offset, offset + PER_PAGE).map((trip, i) => {
      return (
        <div className="trips-container__col" key={i}>
          <TripCard key={`${trip.id}`} trip={trip} />
        </div>
      );
    });
  const pageCount = _.size(data) > 0 && Math.ceil(data.length / PER_PAGE);
  const totalTours = _.size(trips);
  const visibleCardsCounts = _.size(data.slice(offset, offset + PER_PAGE));


  function handlePageClick({ selected: selectedPage }) {
    dispatch(setCurrentPage(selectedPage));
    const filterBar  = document.getElementById('ylg__site-search-settings_filter-bar')
    if (filterBar) {
      filterBar.scrollIntoView()
    }
  }

  const visibleCards = Boolean(visibleCardsCounts)
    ? `${offset + 1} - ${offset + visibleCardsCounts}`
    : visibleCardsCounts
  const viewingCountLabel = `Viewing <strong>${visibleCards}</strong> of ${totalTours}`

  return (
    <>
      <div className="u-flex pagination__top">
        <span dangerouslySetInnerHTML={{ __html: viewingCountLabel }} />
      </div>

      <div className="u-flex trips-container">{currentPageData}</div>
      <div className="u-flex pagination__wrapper">
        {_.size(data) > PER_PAGE && (
          <>
            <div className="pagination__status">
              <span dangerouslySetInnerHTML={{ __html: viewingCountLabel }} />
            </div>
            <ReactPaginate
              forcePage={currentPage}
              marginPagesDisplayed={1}
              previousLabel=""
              nextLabel=""
              pageCount={pageCount}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              previousLinkClassName={'pagination__previous pagination__link'}
              nextLinkClassName={'pagination__next pagination__link'}
              disabledClassName={'pagination__link__disabled'}
              activeClassName={'pagination__link__active'}
            />
          </>
        )}
      </div>
    </>
  );
};

export default TripsContainer;
